import React from 'react'

const About = () => {
  return (
    <div className="container-fluid about overflow-hidden py-5">
        <div className="container py-5">
            <div className="row g-5">
                <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
                    <div className="about-img rounded h-100">
                        <img style={{backgroundPosition: 'center bottom', objectFit: 'cover'}} src='img/cicd-logo-transparent.png' className="img-fluid rounded h-100 w-100" alt="CICD Logo" />
                        <div className="about-exp"><span>5+ Years of Experience</span></div>
                    </div>
                </div>
                <div className="col-xl-6 wow fadeInRight" data-wow-delay="0.2s">
                    <div className="about-item">
                        <h4 className="text-primary text-uppercase">About Us</h4>
                        <h5 className="display-3 mb-3">PHG Africa</h5>
                        <p className="mb-4">PHG has over the years established itself to be an integral partner for rural area development. It has continually advocated for innovation, sustainable enterprise support, community-oriented solutions for rural businesses, Impactful-Developmental models testing, Behaviour Insight Learnings &amp; Primary Health Innovations solutions.</p>
                        <p>
                            PHG Foundation is a Not-for-Profit Projects Innovation Design and Sustainable Development Organisation, with focus on Rural Development Programs, Research &amp; Digital Training Projects, Youth, Women/Child Support Services and Primary Health Innovation Programs.

                            Registered as Social Enterprise in 2015, with active community work in 2017 as Primary Health Vision Care, focusing on Primary Health &amp; Specialist Care Promotion in rural communities.

                            In 2018/19, we embarked upon a number of Social Enterprise Programs for Sustainable Rural Development in Digital Training Consultancies (SMEs) especially for Women &amp; Youth to our existing Primary Health Innovation programs.

                            Currently we conduct these project services and community programs as a Not-for-Profit Organisation. PHG Health Foundation Africa (PHG FOUNDATION), aims to sustain and scale all programs, impacting more Rural Communities, Youth, Women and People in Ghana &amp; Africa. We have a digital – enabled facility with digital tools &amp; products for training activities, Programs design &amp; implementation of community – door step trainings. We have the team to scout, train, engage, and offer sustainable support for the Young Innovators at the grass root and hard to reach areas in partnership with stakeholders.
                        </p>
                        <div className="bg-light rounded p-4 mb-4">
                            <div className="row">
                                <div className="col-12">
                                    <div className="d-flex">
                                        <div className="pe-4">
                                            <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center" style={{width: '80px', height: '80px'}}><i className="fa-solid text-light fa-eye fa-2x"></i></div>
                                        </div>
                                        <div className="">
                                            <a href="#" className="h4 d-inline-block mb-3">Vision Statement</a>
                                            <p className="mb-0">To Sustainably Develop Lives &amp; Rural Communities in Ghana &amp; Africa.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="bg-light rounded p-4 mb-4">
                            <div className="row">
                                <div className="col-12">
                                    <div className="d-flex">
                                        <div className="pe-4">
                                            <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center" style={{width: '80px', height: '80px'}}><i className="fa-solid fa-signs-post text-light fa-2x"></i></div>
                                        </div>
                                        <div className="">
                                            <a href="#" className="h4 d-inline-block mb-3">Mission Statement</a>
                                            <p className="mb-0">To deliver Sustainable Rural Development &amp; Digital Research Projects in Africa focusing on Digi Skills Training, Community Health Promotion, Women, Youth &amp; Girls Social Enterprise Development.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a href="#" className="btn btn-secondary rounded-pill py-3 px-5">Read More</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default About